import { useMutationState as r } from "@tanstack/react-query";
function c() {
  const e = r({
    filters: { mutationKey: ["generate-token"] },
    select: (n) => n == null ? void 0 : n.state
  }), s = e == null ? void 0 : e[(e == null ? void 0 : e.length) - 1];
  return (s == null ? void 0 : s.status) !== "pending";
}
export {
  c as u
};
